import React, { useEffect, useState } from "react";
import fetchWithAuth from "../fetchWithAuth";

function formatParseDate(value) {
  if (!value) return "ещё не выполнялся";
  const date = new Date(value);
  const time = date.toLocaleTimeString("ru-RU", { timeZone: "Europe/Moscow", hour: "2-digit", minute: "2-digit" });
  return `${time} ${date.toLocaleDateString("ru-RU", { timeZone: "Europe/Moscow" })}`;
}

export default function ProjectScheduleSummary({ projectId }) {
  const [data, setData] = useState(null);
  const [error, setError] = useState("");
  useEffect(() => {
    let active = true;
    const controller = new AbortController();
    const load = async () => {
      try {
        const responses = await Promise.all([
          fetchWithAuth(`/api/scheduled-tasks-summary?projectId=${projectId}`, { signal: controller.signal }),
          fetchWithAuth(`/api/project/${projectId}/last-arsenkin`, { signal: controller.signal }),
        ]);
        if (responses.some(response => !response.ok)) throw new Error("Не удалось загрузить сводку расписания");
        const [summary, parsing] = await Promise.all(responses.map(response => response.json()));
        if (active) {
          setData({ total: summary[projectId]?.scheduledTotal ?? 0, today: summary[projectId]?.total ?? 0, lastParse: parsing.date });
          setError("");
        }
      } catch (error) {
        if (active && error.name !== "AbortError") setError("Не удалось загрузить сводку расписания");
      }
    };
    setData(null);
    load();
    const timer = setInterval(load, 30000);
    return () => { active = false; controller.abort(); clearInterval(timer); };
  }, [projectId]);
  return <section aria-label="Сводка расписания" className="rounded-lg bg-white p-4 shadow">
    <div className="flex flex-wrap gap-x-6 gap-y-2 text-sm text-gray-600">
      <div>Последний парсинг: <span className="font-semibold">{data ? formatParseDate(data.lastParse) : error ? "—" : "Загрузка…"}</span></div>
      <div>Заданий в расписании: <span className="font-semibold">{data?.total ?? (error ? "—" : "Загрузка…")}</span></div>
      <div>Из них сегодня (МСК): <span className="font-semibold">{data?.today ?? (error ? "—" : "Загрузка…")}</span></div>
    </div>
    {error && <p role="status" className="mt-2 text-xs text-red-600">{error}</p>}
  </section>;
}
